import { getBaseUrl, getRequestWithTokenInformation } from "services/common";
import { parseTemplate } from "url-template";
import { RequestInit } from "atoms/models";

const addressSearchTemplate: any = parseTemplate(
  "ecommerce/route/addressSearchPage{?item,type,coretype,utm_content,utm_medium,utm_source,utm_campaign}"
);

export const postAddressSearchPage = async (
  locationId: number,
  movingExistingService?: boolean | null,
  item?: string | null,
  type?: string | null,
  coretype?: string | null,
  utm_content?: string | null,
  utm_medium?: string | null,
  utm_source?: string | null,
  utm_campaign?: string | null
) => {
  const baseUrl = getBaseUrl();
  const relativeUrl = addressSearchTemplate.expand({ item, type, coretype, utm_content, utm_medium, utm_source, utm_campaign });
  const input = new URL(relativeUrl, baseUrl).href;
  const headers = new Headers();
  headers.append("Accept", "application/json");
  headers.append("Content-Type", "application/json");
  const init: RequestInit = getRequestWithTokenInformation("POST", headers);
  const body = { locationId, movingExistingService, salesChannel: "self service", resBusInd: "R" };
  init["body"] = JSON.stringify(body);
  const response = await window.fetch(input, init);
  const decodedJson = await response.json();
  return decodedJson;
};
